module.exports = __webpack_public_path__ + "img/2.467b69f3.jpg";